<template>
	<div class="myWebsiteMonitor">
		<!-- 网站索引数据 -->
		<clientModule class="indexData" moduletitle="网站索引数据">
			<div slot="moduletitle">
				网站报告

				<!-- 网址切换 -->
				<sky-dropdown-select
					class="site-list"
					@change="changeSite"
					v-model="siteId"
					:options="websiteList"
					:props="{ label: 'name', value: 'id' }"
				></sky-dropdown-select>
			</div>
			<div>
				<websiteMonitorDetails
					:details="details"
					:showStatus="showStatus"
          :siteId="siteId"
					v-if="!loading"
					@refresh="refresh"
				></websiteMonitorDetails>

				<div class="loading_body" v-else>
					<img :src="loadingImg" alt="" />
					<span class="loading_text">数据正在努力生成，请稍后查看</span>
				</div>
			</div>
		</clientModule>
	</div>
</template>

<script>
import websiteMonitorDetails from './websiteMonitorDetails';
// import mixinsWatch from '@/backend/mixinsWatch/mixinsWatch';
import websiteMonitor from '@/backend/services/websiteMonitor/websiteMonitor.js';
import loadingImg from '@/assets/websiteMonitor/loadingImg.png';
import clientModule from '@/components/client/clientModule/clientModule';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import { mapGetters } from 'vuex';

export default {
	name: 'myWebsiteMonitor',
	components: {
		websiteMonitorDetails,
		clientModule,
		skyDropdownSelect,
	},
	// mixins: [mixinsWatch],
	data() {
		return {
			siteId: '',
			websiteList: [],
			details: null,
			timer: null,
			resultsId: '',
			loading: true,
			showStatus: 1,
			loadingImg,
			refreshStatus: false,
		};
	},
	computed: {
		...mapGetters(['customerId']),
	},
	watch: {
		customerId: {
			async handler(val) {
				if (val) this.getWebsite();
				else this.$message.warning('您需要先选择一个客户');
			},
			immediate: true,
			deep: true,
		},
	},
	destroyed() {
		if (this.timer) window.clearInterval(this.timer);
	},
	methods: {
		init() {
			if (this.timer) window.clearInterval(this.timer);
			this.getMonitorMyResults();
		},
		// 网站下拉数据
		async getWebsite() {
			try {
				let { customerId } = this;
				let result = await getWebsiteByCustomer({
					customerId,
				});
				this.websiteList = result.data;
				if (result.data.length == 0) return false;
				this.siteId = result.data[0].id;
				this.init();
			} catch (error) {
				console.log(error);
			}
		},
		// 网址选择切换
		changeSite(id) {
			let obj = this.websiteList.find(item => {
				return item.id === id;
			});
			this.siteId = obj.id;
			this.init();
		},
		// 获取我的网站报告
		async getMonitorMyResults() {
			if (this.timer) window.clearInterval(this.timer);
			let { siteId: serviceSiteId } = this;
			let res = await websiteMonitor.getMonitorMyResults({
				serviceSiteId,
			});
			if (res) {
				if (!res?.data?.id) this.start();
				if (res.data.testStatus !== 1) this.judgeState(res.data);
				else {
					this.resultsId = res.data.id;
					await this.getResults();
					this.timer = window.setInterval(() => {
						window.setTimeout(this.getResults, 0);
					}, 3000);
				}
			}
		},
		refresh() {
			if (this.refreshStatus) return;
			this.refreshStatus = true;
			this.showStatus = 1;
			this.start();
		},
		// 开始检测 并轮询检测结果接口
		async start() {
			if (this.timer) window.clearInterval(this.timer);
			let { siteId: serviceSiteId } = this;
			let res = await websiteMonitor.getMonitorId({
				serviceSiteId,
			});
			if (res) {
				this.resultsId = res.data;
				await this.getResults();
				this.timer = window.setInterval(() => {
					window.setTimeout(this.getResults, 0);
				}, 3000);
			}
		},
		// 获取检测详情
		async getResults() {
			this.loading = true;
			let { resultsId: id } = this;
			let res = await websiteMonitor.getMonitorResults({
				id,
			});
			if (res) {
				let { data } = res;
				if (data.testStatus !== 1) {
					this.judgeState(data);
					window.clearInterval(this.timer);
				}
			}
		},
		// 状态判断
		judgeState(data) {
			let { testStatus } = data;
			this.refreshStatus = false;
			// showStatus(1：成功  2:：异常  3：失败)
			switch (testStatus) {
				case 2:
					this.loading = false;
					this.showStatus = 1;
					this.details = data;
					break;
				case 3:
					this.loading = false;
					this.showStatus = 2;
					break;
				case 4:
					this.loading = false;
					this.showStatus = 3;
					break;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.myWebsiteMonitor {
	overflow: auto;
	height: 100%;
	margin: 0px 20px 10px 20px;

	.indexData {
		background-color: #fff;
	}

	.site-list {
		margin-left: 20px;
	}

	.loading_body {
		height: calc(100vh - 175px);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #fff;

		.loading_text {
			font-size: 20px;
			font-weight: 500;
			margin-top: 20px;
		}
	}
}
</style>
